import type {CheckoutProfileRuleConditions} from '@dms/api/sales';

export const EMPTY_CHECKOUT_RULE_CONDITIONS: CheckoutProfileRuleConditions = {
  serviceCaseTypeIds: null,
  serviceOrderTypeIds: null,
  serviceOrderVariantIds: null,
  authorizationProfileIds: null,
  directSaleTypeIds: null,
  directSaleVariantIds: null,
};
